import React from "react";
import styled, { keyframes } from "styled-components";

interface ILoader {
    size?: number;
}

const rotate = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`;

const dash = keyframes`
    0% {
        stroke-dasharray: 3, 33;
        stroke-dashoffset: 0;
    }
    100% {
        stroke-dasharray: 30, 33;
        stroke-dashoffset: -36;
    }
`;

const LoaderWrapper = styled.span<ILoader>`
    height: ${({ size }) => size || 1}em;
    width: ${({ size }) => size || 1}em;
    svg {
        height: ${({ size }) => size || 1}em;
        width: ${({ size }) => size || 1}em;
        stroke: currentColor;
        stroke-width: 1;
        animation: ${rotate} 2s ease-in-out infinite;
        transform-origin: center center;
        circle {
            stroke-dasharray: 1, 33;
            stroke-dashoffset: 0;
            animation: ${dash} 1.5s linear infinite;
        }
    }
`;

const Loader = ({ size }: ILoader): JSX.Element => {
    return (
        <LoaderWrapper size={size}>
            <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="6" cy="6" r="5.25" strokeLinecap="round" />
            </svg>
        </LoaderWrapper>
    );
};

Loader.defaultProps = {
    size: undefined
};

export default Loader;
